import React from 'react';
import { Button } from './Button';
import { Calculator } from 'lucide-react';
export function Financing() {
  return <section className="py-20 bg-white border-b border-gray-100" data-id="element-73">
      <div className="container mx-auto px-4" data-id="element-74">
        <div className="bg-tx-light rounded-3xl p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-75">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-tx-navy/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-76"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-tx-red/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3" data-id="element-77"></div>

          <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-78">
            <div data-id="element-79">
              <div className="w-16 h-16 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-6" data-id="element-80">
                <Calculator className="w-8 h-8 text-tx-navy" data-id="element-81" />
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-tx-deep mb-6 tracking-tight" data-id="element-82">
                Flexible Roof Financing
              </h2>
              <p className="text-lg text-tx-body leading-relaxed mb-8" data-id="element-83">
                Paying for a roof is hard. We partner with a lender to offer
                simple financing for roof costs and insurance deductibles, with
                options for a range of credit scores. Find out if you qualify.
              </p>
              <Button className="bg-tx-navy hover:bg-tx-navy/90 text-white font-bold px-8 h-14 rounded-lg text-lg" data-id="element-84">
                See If You Qualify
              </Button>
            </div>

            <div className="hidden lg:block relative" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/598vyCE4Q7MxdFXfzZMfDi/TXD-Roofing5.jpg" alt="Texas Direct crew staging roofing materials at a DFW job site" className="rounded-2xl shadow-xl object-cover aspect-[4/3]" data-id="element-86" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}